import { get, getRawValue } from '../../../utils/get';
import { CONTEXT_PROPS } from '../../../types/ContextProps';
import { getKeys, siteIDs, hasMissingSchemaVariables, } from '../../../adapters/utils';
var IDs = {
    INDEX_PAGE: 'page.index',
    POST_CONTENT: 'post.description',
    POST_CONTENT_60: 'group.post.content.60',
    POST_CONTENT_200: 'group.post.content.200',
    GROUP_NAME: 'group.name',
    POST_URL: 'group.post.url',
    POST_AUTHOR: 'groups.post.author',
    POST_PUBLISH_DATE: 'groups.post.publish.date',
    POST_MODIFIED_DATE: 'groups.post.modified.date',
    DISABLE_SCHEMA: 'groups.post.disable-schema',
    POST_OWNER_IMAGE_HEIGHT: 'post.owner.image.height',
    POST_OWNER_IMAGE_WIDTH: 'post.owner.image.width',
    POST_OWNER_IMAGE_URL: 'post.owner.image.url',
    COMMENTS_COUNT: 'post.comments.count',
    LIKE_COUNT: 'post.interaction.like.count',
    POST_IMAGE_HEIGHT: 'post.coverImage.height',
    POST_IMAGE_WIDTH: 'post.coverImage.width',
    POST_IMAGE_URL: 'post.coverImage.url',
    POST_PUBLISHER_ID: 'publisher.id',
    POST_PUBLISHER_LOGO_URL: 'publisher.logo.url',
};
var userVisible = [];
var requiredSchemaVariables = [siteIDs.BUSINESS_LOGO, siteIDs.SITE_NAME];
export default {
    IDs: IDs,
    requiredSchemaVariables: requiredSchemaVariables,
    getData: function (item) {
        var _a;
        var postContent = get(item, 'post.entity.body');
        var groupImageURL = get(item, 'group.details.logoUrl');
        return _a = {},
            _a[IDs.INDEX_PAGE] = getRawValue(item, "context." + CONTEXT_PROPS.INDEX_PAGE),
            _a[IDs.POST_CONTENT] = postContent,
            _a[IDs.POST_CONTENT_60] = postContent.substring(0, 60),
            _a[IDs.POST_CONTENT_200] = postContent.substring(0, 200),
            _a[IDs.GROUP_NAME] = get(item, 'group.details.title'),
            _a[IDs.POST_URL] = get(item, ''),
            _a[IDs.POST_AUTHOR] = get(item, 'author.name.nick'),
            _a[IDs.POST_PUBLISH_DATE] = get(item, 'post.createdAt'),
            _a[IDs.POST_MODIFIED_DATE] = get(item, ''),
            _a[IDs.DISABLE_SCHEMA] = hasMissingSchemaVariables(requiredSchemaVariables, item),
            _a[IDs.POST_OWNER_NAME] = get(item, 'author.name.nick'),
            _a[IDs.POST_OWNER_IMAGE_HEIGHT] = get(item, ''),
            _a[IDs.POST_OWNER_IMAGE_WIDTH] = get(item, ''),
            _a[IDs.POST_OWNER_IMAGE_URL] = get(item, 'author.imageUrl'),
            _a[IDs.COMMENTS_COUNT] = get(item, 'post.comments.total'),
            _a[IDs.LIKE_COUNT] = get(item, 'interactionStatistic'),
            _a[IDs.POST_IMAGE_HEIGHT] = get(item, ''),
            _a[IDs.POST_IMAGE_WIDTH] = get(item, ''),
            _a[IDs.POST_IMAGE_URL] = get(item, 'attachments.0.uri') || groupImageURL,
            _a[IDs.POST_PUBLISHER_ID] = get(item, ''),
            _a[IDs.POST_PUBLISHER_LOGO_URL] = groupImageURL,
            _a;
    },
    getLegacySeoBlob: function () { },
    getSlug: function () { return ''; },
    updateItemDataWithSlug: function (item) { return item; },
    getBiData: function () { },
    getKeys: function () { return getKeys(IDs, userVisible); },
};
